import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../editable-cell'

interface WhitewashProps {}

const Whitewash: FC<WhitewashProps> = () => {
    const ctx = useContext(EditableCellCtx)
    return (
        <Form.Item name={'whitewash'} noStyle>
            <InputNumber autoFocus onBlur={ctx.onBlur} controls={false} />
        </Form.Item>
    )
}

export default Whitewash
